import i18next from 'i18next';
import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    addCustomerPaymentMethod,
    deactivateCustomerPaymentMethod,
    fetchAllAdminCustomerpaymentMethods,
    fetchAllCustomerPaymentMethods,
} from 'src/api/customer/paymentMethods';
import { enqueueSnackbarAction } from 'src/store/notifications/actions';
import {
    ADD_CUSTOMER_PAYMENT_METHOD,
    DEACTIVATE_CUSTOMER_PAYMENT_METHOD,
    fetchCustomerPaymentMethods,
    fetchCustomerPaymentMethodsAdmin,
    FETCH_CUSTOMER_PAYMENT_METHODS,
    FETCH_CUSTOMER_PAYMENT_METHODS_ADMIN,
    requestAddCustomerPaymentMethod,
    requestAddCustomerPaymentMethodFailure,
    requestAddCustomerPaymentMethodSuccess,
    requestCustomerPaymentMethods,
    requestCustomerPaymentMethodsAdmin,
    requestCustomerPaymentMethodsAdminFailure,
    requestCustomerPaymentMethodsAdminSuccess,
    requestCustomerPaymentMethodsFailure,
    requestCustomerPaymentMethodsSuccess,
    requestDeactivateCustomerPaymentMethod,
    requestDeactivateCustomerPaymentMethodFailure,
    requestDeactivateCustomerPaymentMethodSuccess,
} from './actions';

/* Customer Payment Methods */
function* fetchCustomerPaymentMethodsSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerPaymentMethods());

    const { error, response } = yield call(fetchAllCustomerPaymentMethods);

    if (error) yield put(requestCustomerPaymentMethodsFailure(error));
    else yield put(requestCustomerPaymentMethodsSuccess(response));
}

function* addCustomerPaymentMethodSaga(action: AnyAction): SagaIterator {
    yield put(requestAddCustomerPaymentMethod());

    const { error, response } = yield call(addCustomerPaymentMethod, action.customerPaymentMethod);

    if (error) {
        yield put(requestAddCustomerPaymentMethodFailure(error));
        yield put(
            enqueueSnackbarAction({
                message: i18next.t('office:pages.customerprofile.overview.paymentMethod.add.error'),
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'error',
                },
            })
        );
    } else {
        yield put(fetchCustomerPaymentMethods());
        yield put(fetchCustomerPaymentMethodsAdmin());
        yield put(requestAddCustomerPaymentMethodSuccess(response));
        yield put(
            enqueueSnackbarAction({
                message: i18next.t('office:pages.customerprofile.overview.paymentMethod.add.success'),
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'success',
                },
            })
        );
    }
}

function* deactivateCustomerPaymentMethodSaga(action: AnyAction): SagaIterator {
    yield put(requestDeactivateCustomerPaymentMethod());

    const { error, response } = yield call(deactivateCustomerPaymentMethod, action.customerPaymentMethodId);

    if (error) {
        yield put(requestDeactivateCustomerPaymentMethodFailure(error));
        yield put(
            enqueueSnackbarAction({
                message: i18next.t('office:pages.customerprofile.overview.paymentMethod.deactivateError'),
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'error',
                },
            })
        );
    } else {
        yield put(fetchCustomerPaymentMethods());
        yield put(fetchCustomerPaymentMethodsAdmin());
        yield put(requestDeactivateCustomerPaymentMethodSuccess(response));
    }
}

export function* generateFetchCustomerPaymentMethodsWatcher() {
    yield takeLatest(FETCH_CUSTOMER_PAYMENT_METHODS, fetchCustomerPaymentMethodsSaga);
}

export function* generateAddCustomerPaymentMethodsWatcher() {
    yield takeLatest(ADD_CUSTOMER_PAYMENT_METHOD, addCustomerPaymentMethodSaga);
}

export function* generateDeactivateCustomerPaymentMethodsWatcher() {
    yield takeLatest(DEACTIVATE_CUSTOMER_PAYMENT_METHOD, deactivateCustomerPaymentMethodSaga);
}

/* Admin Customer Paymnent Methods */
function* fetchCustomerPaymentMethodsAdminSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerPaymentMethodsAdmin());

    const { error, response } = yield call(fetchAllAdminCustomerpaymentMethods);

    if (error) yield put(requestCustomerPaymentMethodsAdminFailure(error));
    else yield put(requestCustomerPaymentMethodsAdminSuccess(response));
}

export function* generateFetchCustomerPaymentMethodsAdminWatcher() {
    yield takeLatest(FETCH_CUSTOMER_PAYMENT_METHODS_ADMIN, fetchCustomerPaymentMethodsAdminSaga);
}
